import { FontWeights } from './interfaces'

export const fontWeights: FontWeights = {
  thin: 300,
  regular: 400,
  medium: 500,
  bold: 700,
}
